<template>
  <div class="relative w-full lg:h-[70vh] h-[30vh]">
    <!-- Background Image -->
    <div class="absolute inset-0 overflow-hidden">
      <img
        src="../assets/images/HERO Pages ALL 2.png"
        alt="Background"
        class="w-full h-full object-cover"
      />
      <div class="absolute inset-0 bg-black opacity-50"></div>
    </div>

    <!-- Content Wrapper -->
    <div
      class="relative max-w-screen-4xl mx-auto h-full flex flex-col lg:flex-row items-center justify-center px-6 lg:px-32"
    >
      <h2
        class="text-white text-center text-3xl font-black animate__animated animate__backInLeft"
      >
        FAQ
      </h2>
    </div>

    <!-- SVG Curve (Aligned to Background) -->
    <svg viewBox="0 0 1440 320" class="absolute bottom-0 left-0 w-full">
      <path
        fill="#ffffff"
        d="M0,224L80,208C160,192,320,160,480,176C640,192,800,256,960,266.7C1120,277,1280,235,1360,213.3L1440,192V320H0Z"
      ></path>
    </svg>
  </div>

  <!-- Frequently asked questions -->
  <div class="md:px-10 max-w-screen-xl mx-auto relative z-10 mt-4 px-6 lg:-mt-20">
    <div class="text-start">
      <h3 class="text-yellow font-bold text-4xl">
        FREQUENTLY ASKED <br> QUESTIONS
      </h3>
    </div>
    <div class="text-center py-10">
      <p class="mt-4 mb-6 text-gray-600">
        Welcome to our FAQ section where we answered commonly asked questions
        about our products, services, and more. This will give you better
        insight into what we do at Mshel Homes!
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 py-10">
      <div v-for="(faq, index) in faqs" :key="index">
        <div class="bg-white shadow-lg rounded-2xl overflow-hidden">
          <button
            class="w-full text-left px-5 py-3 bg-gray-100 font-semibold text-gray-800 flex justify-between items-center focus:outline-none"
            @click="toggleFAQ(index)"
          >
            <span>{{ faq.question }}</span>
            <svg
              :class="{ 'rotate-180': faq.open }"
              class="w-5 h-5 text-gray-600 transition-transform duration-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </button>

          <!-- Smooth transition for dropdown content -->
          <transition name="faq-slide">
            <div v-if="faq.open" class="px-5 py-3 text-gray-600">
              {{ faq.answer }}
            </div>
          </transition>
        </div>
      </div>
    </div>

    <!-- CTA -->
    <div class="text-center mt-16 mb-16">
      <p class="text-gray-700 mb-4 text-lg">Still have questions?</p>
      <button
        class="bg-yellow text-black px-8 py-3 rounded-full font-semibold transition-all duration-300"
      >
        Contact Us
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      faqs: [
        {
          question: "What type of property do Mshel Homes Sell?",
          answer:
            "Mshel Homes sells a variety of properties in Abuja, including estate lands, apartments, houses, and commercial spaces. We also offer a variety of payment plans.",
          open: true,
        },
        {
          question: "Is the land payment inclusive of the infrastructure levy?",
          answer:
            "No, the infrastructure levy depends on the plot size and is paid once the building reaches the carcass level.",
          open: true,
        },
        {
          question: "What is Mshel Homes commitment to customer satisfaction?",
          answer:
            "We offer free consultations, property tours, flexible payment plans, and after-sales support to ensure customer satisfaction.",
          open: false,
        },
        {
          question:
            "How do I get started with buying a property from Mshel Homes?",
          answer:
            "Simply visit our website or contact us via phone or email, and we will assist you.",
          open: false,
        },
        {
          question:
            "Can we make adjustments to support a different kind of building design?",
          answer:
            "Yes, you can customize the interior with our design team, but the exterior must remain uniform.",
          open: false,
        },
      ],
    };
  },
  methods: {
    toggleFAQ(index) {
      this.faqs[index].open = !this.faqs[index].open;
    },
  },
};
</script>

<style scoped>
button {
  transition: background-color 0.3s ease-in-out;
}
button:hover {
  background-color: #e2e8f0;
}
.faq-slide-enter-active,
.faq-slide-leave-active {
  transition: max-height 0.3s ease-out, opacity 0.3s ease-out;
  overflow: hidden;
}

.faq-slide-enter-from,
.faq-slide-leave-to {
  max-height: 0;
  opacity: 0;
}

.faq-slide-enter-to,
.faq-slide-leave-from {
  max-height: 200px;
  opacity: 1;
}

.story-style {
  font-family: "Caveat";
}

svg path {
  fill: #ffffff !important;
  stroke: none !important;
  box-shadow: none !important;
}

svg {
  overflow: hidden !important;
}

.absolute.bottom-0 {
  line-height: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: -2px;
}

.overflow-hidden {
  overflow: hidden !important;
}

.who-style {
  font-family: Montserrat;
}

.strategic-card {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 1s ease-out, transform 1s ease-out;
  will-change: opacity, transform;
}

.strategic-card.fade-in {
  opacity: 1;
  transform: translateY(0);
}

.strategic-card:hover {
  transform: scale(1.03);
  /* box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2); */
  transition: transform 0.4s ease-out, box-shadow 0.4s ease-out;
  /* background-color: inherit !important; */
  box-shadow: none !important;
}

.fade-section {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 1s ease-out, transform 1s ease-out;
}
.fade-section.fade-in {
  opacity: 1;
  transform: translateY(0);
}
</style>
